import { yup } from '@framework/validation';
import { BooleanConditionSchema } from '../../inputs/expressions-editor/conditions/BooleanConditionSchema';
import { WidgetDirectivesSchema } from '../directives/WidgetDirectivesSchema';
import { IBaseWidget } from './IBaseWidget';
import { WidgetType } from './Widget';
import { BaseLayoutSchema } from './repository/common/BaseLayoutSchema';

export const CommonBaseWidgetSchema: yup.ObjectSchema<IBaseWidget> = yup
  .object({
    id: yup.string().required(),
    order: yup.number().required().default(0),
    path: yup.array().required().default([]),

    type: yup.string().oneOfEnum(WidgetType).required(), // Qui `oneOfEnum` è corretto perché ulteriori tipi di widget sovrascrivono il validatore per `type` con `.exact`

    // Layout
    layout: BaseLayoutSchema,

    fromVirtualId: yup.string(),

    // Direttive
    directives: WidgetDirectivesSchema,
    // Regole di visibilità
    visible: BooleanConditionSchema,
    enabled: BooleanConditionSchema,
  })
  .required()
  .noUnknown();
